
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';

import "./besoinsList.css";

class BesoinList extends PureComponent {
  static defaultProps = {
    className: "",
  };
  constructor(props) {
    super(props);
  }
  componentDidMount() {

  }

  render() {
    return (
      <ul className={`services-list ${this.props.className}`}>
        {this.props.children && this.props.children.map(function (child, id) {

          return <React.Fragment key={id}>{child}</React.Fragment>;


        })}
      </ul>
    );
  }
}
export default BesoinList;
